import React, { useState, useEffect } from 'react';
import { Form, Row, FormText, Container } from 'react-bootstrap';
import * as apiUtility from "../../config/APIUtils";
import { TbSquareRoundedNumber1, TbSquareRoundedNumber2, TbSquareRoundedNumber3, TbSquareRoundedNumber4, TbSquareRoundedNumber5, TbXboxX } from "react-icons/tb";
import { Button, FormLabel, Sheet } from '@mui/joy';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import { DialogActions, DialogContent, DialogTitle, Stack } from '@mui/joy';


const passVerificationError = {
    isLengthy: false,
    hasUpper: false,
    hasLower: false,
    hasNumber: false,
    hasSpecChar: false,
    confirmPassword: false
}


function ChangePassword(props) {

    let defaultPassword = props.defaultPassword;
    var user = props.username;
    var userId = props.userId;
    var isAdmin = props.isAdmin;

    const [username, setUsername] = useState("");
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [emailId, setEmailId] = useState("");
    const [adminPassword, setAdminPassword] = useState("");
    const [passwordError, setPasswordError] = useState(passVerificationError);


    useEffect(() => {
        if (defaultPassword) {
            setAdminPassword(String(defaultPassword));
        }
    }, [defaultPassword]);
    
    
    const handleOnChange = e => {
        setUsername(user);
        const { name, value } = e.target

        if (name === 'oldPassword') {
            setOldPassword(value);
        }

        if (name === 'confirmPassword') {
            setConfirmPassword(value);
            setPasswordError({ ...passwordError, confirmPassword: newPassword === value });
        }

        if (name === 'adminPassword') {
            setAdminPassword(value);
        }

        if (name === "newPassword") {
            setNewPassword(value);
            const isLengthy = value.length >= 8;
            const hasUpper = /[A-Z]/.test(value);
            const hasLower = /[a-z]/.test(value);
            const hasNumber = /[0-9]/.test(value);
            const hasSpecChar = /[@,#,$,%,&,*,!]/.test(value);

            setPasswordError({ ...passwordError, isLengthy, hasLower, hasUpper, hasNumber, hasSpecChar });
        }
    };

    const handleOnSubmit = async e => {
        e.preventDefault();
        let apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = "login/change-password";
        apiRequest.data = { "login_id": username, "oldPassword": oldPassword, "newPassword": newPassword, "istemp": false };
        await apiUtility.sendAsyncAPIDataPOST(apiRequest).then(res => {
            if (res.data.msg === "Password updated successfully!") {
                props.handleUpdateCallback(res.data.msg);
            } else {
                setEmailId(res.data.msg);
            }
        }).catch(err => {
            setEmailId("Something went wrong!");
            console.log("Error: ", err);
        });
    }

    const passwordResetByAdmin = async e => {
        if (adminPassword === "") {
            setEmailId("Please enter admin password!");
            return;
        }
        e.preventDefault();
        let apiRequest = apiUtility.apiInputRequest;
        // apiRequest.endPoint = "login/admin-password-reset";
        // apiRequest.data = { "login_id": props.data, "adminPassword": adminPassword };
        
        apiRequest.endPoint = "login/reset-default-password";
        apiRequest.data = { "user_id": userId, "login_id": props.username, "newPassword": adminPassword }

        await apiUtility.sendAsyncAPIDataPOST(apiRequest).then(res => {
            if (res.data.msg === "Password updated successfully!") {
                props.handleUpdateCallback(res.data.msg);
            } else {
                setEmailId(res.data.msg);
            }
        }).catch(err => {
            setEmailId("Something went wrong!");
            console.log("Error: ", err);
        });
    }

    return (

        <Modal open={props.show} onClose={props.onHide} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} disableScrollLock={true}>
            <ModalDialog sx={{ opacity: props.show ? 1 : 0, transition: `opacity 300ms` }}>
                <DialogTitle sx={{ pb: 2, color: "#006699" }}>Update Password</DialogTitle>
                <DialogContent>
                    <Container style={{ "width": "100%" }}>
                        {(isAdmin) && 
                            <Row className='text-center'>
                                <Sheet variant="outlined" color="primary" sx={{ p: 2, borderRadius: "md", display: "flex" }}>
                                    <Stack direction={"row"} justifyContent="center" alignItems="center" spacing={3} sx={{ width: "100%" }}>
                                        <Stack direction="column" justifyContent="center" alignItems="center" spacing={1}>
                                            <FormLabel sx={{p:1}}>Admin Password</FormLabel>
                                            <Form.Group style={{minWidth:300}} controlId="formadminPassword">
                                                <Form.Control style={{ "width": "100%" }} type="text" name="adminPassword" onChange={handleOnChange} value={adminPassword}  />
                                            </Form.Group>
                                        </Stack>
                                        <Stack direction="column" justifyContent="flex-end" alignItems="flex-end" spacing={1}>
                                            <Button variant='solid' color='primary' type="submit" onClick={passwordResetByAdmin} >
                                                Reset Password
                                            </Button>
                                        </Stack>
                                    </Stack>
                                </Sheet>
                                 <p className='text-muted'> {emailId}</p>
                            </Row>
                        }
                    </Container>
                    <Container style={{ "width": "90%" }}>    
                        <Row className='text-center'>
                            <Form.Group as={Row} className="m-3" controlId="formGridPassword">
                                <Form.Control style={{ "width": "100%" }} type="password" name="oldPassword" onChange={handleOnChange} value={oldPassword} required placeholder="Enter your current password" />
                            </Form.Group>
                            <Form.Group as={Row} className="m-3" controlId="formGridPassword">
                                <Form.Control style={{ "width": "100%" }} type="password" name="newPassword" onChange={handleOnChange} value={newPassword} required placeholder="New password" />
                            </Form.Group>
                            <Form.Group as={Row} className="m-3" controlId="formGroupPassword">
                                <Form.Control style={{ "width": "100%" }} type="password" name="confirmPassword" onChange={handleOnChange} value={confirmPassword} required placeholder="Confirm your new password" />
                            </Form.Group>
                        </Row>
                        <FormText as={Row} className='text-left'>
                            <ul className='mb-4'>
                                {!passwordError.confirmPassword && (
                                    <ol className='text-danger'><TbXboxX /> &nbsp;Password mismatch!</ol>
                                )}
                                <ol className={passwordError.isLengthy ? "text-success" : "text-danger"}><TbSquareRoundedNumber1 /> &nbsp;Min 8 characters </ol>
                                <ol className={passwordError.hasLower ? "text-success" : "text-danger"}><TbSquareRoundedNumber2 /> &nbsp;At least one lower case </ol>
                                <ol className={passwordError.hasUpper ? "text-success" : "text-danger"}><TbSquareRoundedNumber3 /> &nbsp;At least one upper case </ol>
                                <ol className={passwordError.hasNumber ? "text-success" : "text-danger"}><TbSquareRoundedNumber4 /> &nbsp;At least one number </ol>
                                <ol className={passwordError.hasSpecChar ? "text-success" : "text-danger"}><TbSquareRoundedNumber5 /> &nbsp;At least one special character </ol>
                            </ul>
                        </FormText>
                        <Row className="text-center">
                            <p className='text-muted'> {emailId}</p>
                        </Row>
                    </Container>
                </DialogContent>
                <DialogActions>
                    <Stack direction="row" justifyContent="space-between" alignItems="right" spacing={2}>
                        <Button variant='soft' color='neutral' onClick={props.onHide}>
                            Cancel
                        </Button>
                        <Button variant='solid' color='primary' type="submit" onClick={handleOnSubmit} disabled={Object.values(passwordError).includes(false)} >
                            Change password
                        </Button>
                    </Stack>
                </DialogActions>
            </ModalDialog>
        </Modal>

    );
}
export default ChangePassword;